import { render } from "./Permisos.vue?vue&type=template&id=5f39f0eb&scoped=true"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"

import "./Permisos.vue?vue&type=style&index=0&id=5f39f0eb&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f39f0eb"]])

export default __exports__